<ion-content>

  <ion-button (click)="closeModal()" class="closeButton">
    <ion-icon slot="icon-only" name="close" color="light"></ion-icon>
  </ion-button>
  <ion-icon (click)="swipePrev()" class="clickable leftArrow" color="secondary" src="assets/icon/blackleft-arrow.svg"></ion-icon>
  <ion-slides *ngIf="sliderOptions" #sliderProduct [options]="sliderOptions">
    <ion-slide (click)="closeModal()" *ngFor="let image of productImages">
        <img (click)="$event.stopPropagation();" class="bigProductImage" [src]="image.image">
    </ion-slide>
  </ion-slides>
  <ion-icon (click)="swipeNext()" class="clickable rightArrow" color="secondary" src="assets/icon/blackright-arrow.svg"></ion-icon>
</ion-content>
